const Footer = () => {
  return (
    <footer>
      <div className="container">
        <p>
          created by <a
            href="https://github.com/bluedeepart"
            target="_blank"
            rel="noopener noreferrer"
          >
            bluedeepart
          </a>
          - devChallenges.io
        </p>
      </div>
    </footer>
  );
};

export default Footer;
